import Header from "@/components/Header"
import Hero from "@/components/Hero"
import About from "@/components/About"
import MusicScent from "@/components/MusicScent"
import Edition from "@/components/Edition"
import Fragrance from "@/components/Fragrance"
import Archive from "@/components/Archive"
import OrderForm from "@/components/OrderForm"
import FAQ from "@/components/FAQ"
import KeepFeeling from "@/components/KeepFeeling"
import Footer from "@/components/Footer"

function Home() {
  return (
    <div className="min-h-screen w-full bg-[#080808] text-[#f4efe6]">
      <Header />
      <main>
        <Hero />
        <About />
        <MusicScent />
        <Edition />
        <Fragrance />
        <Archive />
        <OrderForm />
        <FAQ />
        <KeepFeeling />
      </main>
      <Footer />
    </div>
  )
}

export default Home
